import { ArrowBackIcon } from '@/components/Icons';
import { useCofheChainId, useCofheAccount } from '@/hooks/useCofheConnection.js';
import { TransactionItem } from '../components/TransactionItem.js';
import { usePortalNavigation } from '@/stores';
import { useStoredTransactions } from '@/hooks/useStoredTransactions.js';
import { PageContainer } from '../components/PageContainer.js';

export const ActivityPage: React.FC = () => {
  const { navigateBack } = usePortalNavigation();
  const chainId = useCofheChainId();
  const account = useCofheAccount();

  const { filteredTxs: transactions } = useStoredTransactions({
    chainId,
    account,
  });

  return (
    <PageContainer
      header={
        <button
          type="button"
          onClick={navigateBack}
          className="flex items-center gap-1 text-sm hover:opacity-80 transition-opacity mb-2"
        >
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <p className="text-sm font-medium">Activity</p>
        </button>
      }
      content={
        <div className="flex flex-col gap-3">
          {transactions.length === 0 ? (
            <div className="py-8 text-center">
              <p className="text-sm cofhe-text-primary opacity-60">No transactions found</p>
            </div>
          ) : (
            <div className="space-y-2 max-h-64 overflow-y-auto">
              {transactions.map((tx) => (
                <TransactionItem key={tx.hash} transaction={tx} />
              ))}
            </div>
          )}
        </div>
      }
    />
  );
};
